"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var Title = function (_a) {
    var rechargerMoney = _a.rechargerMoney;
    return ((0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ direction: "column", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(LogoAndName_1.default, { brand: rechargerMoney, fontWeight: "medium" }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1, mt: 4, textAlign: "center" }, { children: "Software subscriptions agreement" })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, pt: 10, textAlign: "left", color: "riverstone" }, { children: [(0, jsx_runtime_1.jsx)("strong", { children: rechargerMoney.name }), " has partnered with ", (0, jsx_runtime_1.jsx)("strong", { children: "Rechargly" }), " to handle invoices and payments of the software subscriptions that they pay on behalf of your company."] }))] })));
};
exports.default = Title;
